import { EmployeeRolesEnum, EmpPrefixEnum } from "@gtpl/shared-models/common-models";
import { EmployeeEducationDetailsDto, EmployeeExperienceDetailsDto, EmployeeFamilyDetailsDto, EmployeeIdProofDetailsDto, RolesList } from "@gtpl/shared-models/gtpl";

export class HrmsEmployeeDetailsDto{

    employeeType:string;
    employeeId: number;
    employeeCode:string;
    employeeName: string;
    mobileNumber:string;
    employeeRole:EmployeeRolesEnum;
    unitId: number;
    prefix:EmpPrefixEnum;
    dateOfBirth: Date;
    gender:string;
    maritualStatus:string;
    altMobileNumber:string;
    emailID:string;
    bloodGroup:string;
    nationality:string;
    departmentId:string;
    priorityOne:string;
    priorityType:string;
    currentAddress:string;
    permanentAddress:string;
    qualification:string;
    yearsOfExperience:Number;
    companyEmail:string;
    employeeMode:string;
    employeeStatus:string;
    dateOfJoin:Date;
    dateOfleave:Date;
    workstationNumber:string;
    healthCardNumber:string;
    uanNumber:string;
    salary:string;
    bankAccountNumber:string;
    ifscCode:string;
    designation:string;
    dateOfEntry:Date;
    emergencyContactNo:string;
    emergencyContactName:string;
    isProbPeriodCompleted:string;
    skillSet:string;
    isActive: boolean;
    createdAt : Date;
    createdUser : string;
    updatedAt : Date;
    updatedUser : string;
    versionFlag : number;
    familyDetails?: EmployeeFamilyDetailsDto[];
    educationDetails?:EmployeeEducationDetailsDto[];
    experienceDetails?:EmployeeExperienceDetailsDto[];
    idProofDetails?:EmployeeIdProofDetailsDto[];
    employeeLastName?:string;
    Fname?:string;
    adhaarCard?:number;
    mobilePhone?:number;
    address?:string;
constructor( 
    employeeType:string,
    employeeId: number,
    employeeCode:string,
    employeeName: string,
    mobileNumber:string,
    employeeRole:EmployeeRolesEnum,
    unitId: number,
    prefix:EmpPrefixEnum,
    dateOfBirth: Date,
    gender:string,
    maritualStatus:string,
    altMobileNumber:string,
    emailID:string,
    bloodGroup:string,
    nationality:string,
    departmentId:string,
    priorityOne:string,
    priorityType:string,
    currentAddress:string,
    permanentAddress:string,
    qualification:string,
    yearsOfExperience:Number,
    companyEmail:string,
    employeeMode:string,
    employeeStatus:string,
    dateOfJoin:Date,
    dateOfleave:Date,
    workstationNumber:string,
    healthCardNumber:string,
    uanNumber:string,
    salary:string,
    bankAccountNumber:string,
    ifscCode:string,
    designation:string,
    dateOfEntry:Date,
    emergencyContactNo:string,
    emergencyContactName:string,
    isProbPeriodCompleted:string,
    skillSet:string,
    isActive: boolean,
    createdAt : Date,
    createdUser : string,
    updatedAt : Date,
    updatedUser : string,
    versionFlag : number,
    familyDetails?: EmployeeFamilyDetailsDto[],
    educationDetails?:EmployeeEducationDetailsDto[],
    experienceDetails?:EmployeeExperienceDetailsDto[],
    idProofDetails?:EmployeeIdProofDetailsDto[],
    employeeLastName?:string,
    // Fname?:string,
    // adhaarCard?:number,
    // mobilePhone?:number,
    // address?:string

    ){
        this. employeeType=  employeeType;
        this.employeeId= employeeId;
        this.employeeCode=employeeCode;
        this.employeeName=employeeName;
        this.mobileNumber=mobileNumber;
        this.emailID=emailID;
        this.employeeRole=employeeRole;
        this.unitId=unitId;
        this.prefix=prefix;
        this.dateOfBirth=dateOfBirth;
        this.gender=gender;
        this.maritualStatus=maritualStatus;
        this.altMobileNumber=altMobileNumber;
        this.bloodGroup=bloodGroup;
        this.nationality=nationality;
        this.departmentId=departmentId;
        this.priorityOne=priorityOne;
        this.priorityType=priorityType;
        this.currentAddress=currentAddress;
        this.permanentAddress=permanentAddress;
        this.qualification=qualification;
        this.yearsOfExperience=yearsOfExperience;
        this.companyEmail=companyEmail;
        this.employeeMode=employeeMode;
        this.employeeStatus=employeeStatus;
        this.dateOfJoin=dateOfJoin;
        this.dateOfleave=dateOfleave;
        this.workstationNumber=workstationNumber;
        this.uanNumber=uanNumber;
        this.healthCardNumber=healthCardNumber;
        this.salary=salary;
        this.bankAccountNumber=bankAccountNumber;
        this.ifscCode=ifscCode;
        this.designation=designation;
        this.dateOfEntry=dateOfEntry
        this.emergencyContactName=emergencyContactName;
        this.emergencyContactNo=emergencyContactNo;
        this.isProbPeriodCompleted=isProbPeriodCompleted;
        this.skillSet=skillSet;
        this.familyDetails=familyDetails;
        this.idProofDetails=idProofDetails;
        this.educationDetails=educationDetails;
        this.experienceDetails=experienceDetails;
        this.isActive = isActive;
        this.createdAt = createdAt;
        this.createdUser = createdUser;
        this.updatedAt=updatedAt;
        this.updatedUser=updatedUser;
        this.versionFlag=versionFlag;
        this.employeeLastName=employeeLastName;
        // this.Fname=Fname;
        // this.adhaarCard=adhaarCard;
        // this.mobilePhone=mobilePhone;
        // this.address=address;
    }

}